export default "__VITE_ASSET__BVMWKKnF__"